import { createAction, props } from "@ngrx/store";

const actionKey = '[Conditions Page] ';

export const Enter = createAction(
  actionKey + 'Enter'
);

export const Exit = createAction(
  actionKey + 'Exit'
);
